import type { FC } from 'react';

import Pill from '@/common-components/Pill';
import type { StudentAccountStatus, StudentKycStatus } from '@/types/student.types';

export const KycStatusPill: FC<{ status: StudentKycStatus }> = ({ status }) => {
  if (status === 'auto_approved') {
    return <Pill tone="success">✓ Verified</Pill>;
  }
  return <Pill tone="warn">⏳ Not Submitted</Pill>;
};

export const AccountStatusPill: FC<{ status: StudentAccountStatus }> = ({ status }) => {
  if (status === 'suspended') return <Pill tone="warn">Suspended</Pill>;
  if (status === 'banned') return <Pill tone="danger">Banned</Pill>;
  return <Pill tone="success">Active</Pill>;
};
